// extracted by mini-css-extract-plugin
module.exports = {"category":"Y_d5","wrapp":"Y_d6","category__wrapper":"Y_d7"};